// extracted by mini-css-extract-plugin
export default {"wrapper":"AddText_wrapper__423SE","main":"AddText_main__wW1C4","icon":"AddText_icon__ZXCNJ"};